import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListPartieUnits = () => {
    return axios.get(`/api/Partida/partieUnit/list`, { headers: authHeaderJson() } )
};

const getPartieUnitById = (partieUnitId) => {
        return axios.get(`/api/Partida/partieUnit/${partieUnitId}`, { headers: authHeaderJson() } );
};

const addPartieUnit = (partieUnit) => {
    return axios.post(`/api/Partida/partieUnit/add/`, partieUnit, { headers: authHeaderJson() } );
}

const addPartieUnitList = (partieUnits) => {
    return axios.post(`/api/Partida/partieUnit/add/list`, partieUnits, { headers: authHeaderJson() } );
}

const savePartieUnitById = (partieUnitId, objContract) => {
    return axios.put(`/api/Partida/partieUnit/${partieUnitId}`, objContract, { headers: authHeaderJson() });
};

const deletePartieUnit = (partieUnitId) => {
    return axios.delete(`/api/Partida/partieUnit/${partieUnitId}`, { headers: authHeaderJson() });
}

export {
    getListPartieUnits,
    getPartieUnitById,
    addPartieUnit,
    addPartieUnitList,
    savePartieUnitById,
    deletePartieUnit
}